<ng-container *ngIf="getValue()">{{getValue() | appDate: format}}</ng-container>
